const defaultState = {
	selectOptions: {
		plants: [],
		pgmIds: []
	},
	syncFlags: [],
	dbInfos: [],

	searchParams: {
		plantCd: null,
		pgmId: 'ALL'
	},

	selectedRow: {
		pgmId: '',
		procId: ''
	},

	processes: [],

	sqlDetails: {},

	pagingInfo: {
		currentPage: 1,
		pageUnit: 20
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
